import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import avo from 'analytics/avo';
import Prefetcher from 'components/essentials/Prefetcher';
import IconHeart2 from 'components/icons/iconHeart2';
import IconHeart4 from 'components/icons/iconHeart4';
import useFabricFavs from 'data-hooks/useFabricFavs';
import IconStarFull from 'components/icons/iconStarFull';
import JBImage from 'components/essentials/JBImage';
import SidebarModal from 'components/consumer/SidebarModal';
import MoveItButton from 'components/consumer/MoveItButton';
import FabricAdditionalAttributes from 'components/consumer/FabricAdditionalAttributes';
import PDPFreeSwatchKitButton from 'components/consumer/PDP/PDPFreeSwatchKitButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import useScreen from 'hooks/useScreen';
import IconClose from 'components/icons/iconClose';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useIsBrowser from 'hooks/useIsBrowser';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import PDPFabricReviews from './PDPFabricReviews';
import FabricGallery from '../../GridWithSidebar/components/FabricGallery';
const PDPFabricDetailSidebarUI = t0 => {
  const $ = _c(90);
  const {
    isOpen,
    mode: t1,
    onClose,
    rating,
    reviews,
    selectedFabric,
    galleryType,
    mobileHideHeader: t2
  } = t0;
  const mode = t1 === undefined ? "pdp" : t1;
  const mobileHideHeader = t2 === undefined ? false : t2;
  const history = useHistory();
  const [showAttr, setShowAttr] = useState(false);
  const {
    isMobile,
    isMobileOrTablet
  } = useScreen();
  const showNotificationBannerRef = useRef(null);
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  let t3;
  if ($[0] !== history || $[1] !== isMobile || $[2] !== onClose) {
    t3 = () => {
      if (isMobile) {
        history.goBack();
      }
      onClose();
    };
    $[0] = history;
    $[1] = isMobile;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onCloseClick = t3;
  const {
    actions: t4,
    data: t5
  } = useFabricFavs();
  let t6;
  if ($[4] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const {
    setOptionAsFav,
    removeOptionAsFav
  } = t6;
  let t7;
  if ($[6] !== t5) {
    t7 = t5 === undefined ? {} : t5;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const {
    userFabricFavs: favFabricsObj
  } = t7;
  const isBrowser = useIsBrowser();
  let t8;
  bb0: {
    if (!isBrowser) {
      t8 = "PDP";
      break bb0;
    }
    const pathname = window?.location?.pathname?.toLowerCase();
    if (pathname?.includes("safeguard-fabrics")) {
      t8 = "Safeguard Fabrics Page";
      break bb0;
    }
    if (pathname?.includes("pet-friendly")) {
      t8 = "Pet Friendly Page";
      break bb0;
    }
    if (pathname?.includes("swatches")) {
      t8 = "Swatches";
      break bb0;
    }
    t8 = "PDP";
  }
  const location = t8;
  const t9 = selectedFabric?.option_value_id;
  const t10 = selectedFabric?.option_value;
  const t11 = selectedFabric?.option_color;
  let t12;
  if ($[8] !== location || $[9] !== t10 || $[10] !== t11 || $[11] !== t9) {
    t12 = {
      fabricId: t9,
      fabricName: t10,
      fabricColor: t11,
      location
    };
    $[8] = location;
    $[9] = t10;
    $[10] = t11;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const favProps = t12;
  const isFavorited = !!favFabricsObj?.[selectedFabric?.option_value_id];
  let t13;
  if ($[13] !== favFabricsObj || $[14] !== removeOptionAsFav || $[15] !== setOptionAsFav) {
    t13 = favParams => {
      if (favFabricsObj?.[favParams.fabricId] && removeOptionAsFav) {
        removeOptionAsFav(favParams.fabricId);
        avo.fabricUnfavorited(favParams);
      } else {
        if (!favFabricsObj?.[favParams.fabricId] && setOptionAsFav) {
          setOptionAsFav(favParams.fabricId);
          avo.fabricFavorited(favParams);
        }
      }
    };
    $[13] = favFabricsObj;
    $[14] = removeOptionAsFav;
    $[15] = setOptionAsFav;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const toggleFavClick = t13;
  let t14;
  let t15;
  if ($[17] !== isOpen) {
    t14 = () => {
      if (isOpen) {
        setTimeout(() => setShowAttr(true), 600);
      } else {
        setShowAttr(false);
      }
    };
    t15 = [isOpen];
    $[17] = isOpen;
    $[18] = t14;
    $[19] = t15;
  } else {
    t14 = $[18];
    t15 = $[19];
  }
  useEffect(t14, t15);
  const t16 = !isMobile ? 600 : undefined;
  const t17 = isMobile ? "h-full" : "";
  let t18;
  if ($[20] !== t16 || $[21] !== t17) {
    t18 = {
      height: 300,
      width: t16,
      className: t17
    };
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  const imgixProps = t18;
  let t19;
  bb1: {
    if (selectedFabric?.fabricURL || selectedFabric?.fabricFallbackURL) {
      const t20 = selectedFabric?.fabricURL || selectedFabric?.fabricFallbackURL;
      let t21;
      if ($[23] !== imgixProps || $[24] !== t20) {
        t21 = [{
          url: t20,
          imgixProps
        }];
        $[23] = imgixProps;
        $[24] = t20;
        $[25] = t21;
      } else {
        t21 = $[25];
      }
      t19 = t21;
      break bb1;
    }
    let t20;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = [];
      $[26] = t20;
    } else {
      t20 = $[26];
    }
    t19 = t20;
  }
  const onRenderAssets = t19;
  if (!selectedFabric) {
    return null;
  }
  const t20 = !isMobileOrTablet && selectedFabric?.sliderImages;
  let t21;
  if ($[27] !== t20) {
    t21 = classNames("relative bg-white", {
      "-top-5": t20
    });
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== favProps || $[30] !== galleryType || $[31] !== imgixProps || $[32] !== isFavorited || $[33] !== isMobile || $[34] !== onCloseClick || $[35] !== onRenderAssets || $[36] !== selectedFabric.fabricFallbackURL || $[37] !== selectedFabric.fabricURL || $[38] !== selectedFabric.sliderImages || $[39] !== toggleFavClick) {
    t22 = <div className="h-[300px]">{selectedFabric?.sliderImages && galleryType === "FabricMultiImg" ? <FabricGallery slides={selectedFabric.sliderImages} isMobileMaterialSwatches={true} topRightSide={<button type="button" className={classNames("absolute top-7 right-4 mr-[calc(9%_-_2px)] !border-0 z-[1] items-center bg-white border-solid border-gray-light6 rounded-[48px] cursor-pointer flex h-10 justify-center w-10")} onClick={() => onCloseClick()} aria-label="Close fabric detail sidebar"><IconClose /></button>} bottomRightSide={<button type="button" className={classNames("![background:none] !border-0 !rounded-full !flex !min-h-[34px] !min-w-[34px] !mr-0", "focus:!outline-0", "focus-visible:outline-offset-8", "hover:cursor-pointer", "[&_svg]:!h-8 [&_svg]:!w-8", "[&_svg_path]:!fill-white", "[&:hover_svg_path]:stroke-[#107c8c]", {
        "[&:hover_svg_path]:!fill-brand": !isFavorited
      })} onClick={e => {
        e.stopPropagation();
        toggleFavClick(favProps);
        if (!isFavorited) {
          showNotificationBannerRef.current = true;
        }
      }}>{isFavorited ? <IconHeart2 fill="white" color="white" /> : <IconHeart4 />}</button>} /> : <div className="h-full"><Prefetcher onRenderAssets={onRenderAssets}><JBImage src={selectedFabric.fabricURL} fallbackSrc={selectedFabric.fabricFallbackURL} {...imgixProps} /><div className="absolute top-64 right-[5%] w-fit"><button type="button" className={classNames("![background:none] !border-0 !rounded-full !flex !min-h-[34px] !min-w-[34px] !mr-0", "focus:!outline-0", "focus-visible:outline-offset-8", "hover:cursor-pointer", "[&_svg]:!h-8 [&_svg]:!w-8", "[&_svg_path]:!fill-white", "[&:hover_svg_path]:stroke-[#107c8c]", {
              "relative bottom-5": isMobile,
              "[&:hover_svg_path]:!fill-brand": !isFavorited
            })} onClick={e_0 => {
              e_0.stopPropagation();
              toggleFavClick(favProps);
              if (!isFavorited) {
                showNotificationBannerRef.current = true;
              }
            }}>{isFavorited ? <IconHeart2 fill="white" color="white" /> : <IconHeart4 />}</button></div></Prefetcher></div>}</div>;
    $[29] = favProps;
    $[30] = galleryType;
    $[31] = imgixProps;
    $[32] = isFavorited;
    $[33] = isMobile;
    $[34] = onCloseClick;
    $[35] = onRenderAssets;
    $[36] = selectedFabric.fabricFallbackURL;
    $[37] = selectedFabric.fabricURL;
    $[38] = selectedFabric.sliderImages;
    $[39] = toggleFavClick;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== galleryType || $[42] !== onCloseClick) {
    t23 = galleryType === "FabricSingleImg" && <MoveItButton className="absolute top-6 right-[calc(1%_-_5px)] mr-[calc(4%_-_2px)] !bg-white !border-0" onClick={onCloseClick} />;
    $[41] = galleryType;
    $[42] = onCloseClick;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  const t24 = selectedFabric.exclude_from_sale ? " - Limited Edition" : "";
  let t25;
  if ($[44] !== selectedFabric.option_value || $[45] !== t24) {
    t25 = <h2 className="text-2xl font-bold m-0">{selectedFabric.option_value}{t24}</h2>;
    $[44] = selectedFabric.option_value;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== rating || $[48] !== reviews) {
    t26 = reviews?.length > 0 && <div className="flex items-center [&_span]:flex [&_span]:items-center my-2 mx-0"><span><IconStarFull className="relative -top-px w-[11px] h-[11px] max-w-[inherit] mr-[.2rem] [&_path]:fill-yellow [&_path]:stroke-[none]" /></span>{rating > 0 && <><span className="text-xs">{rating}/5</span> </>}<span className="text-xs">({reviews.length} review{reviews.length > 1 ? "s" : ""})</span></div>;
    $[47] = rating;
    $[48] = reviews;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== selectedFabric.greenguard_fabric || $[51] !== selectedFabric.group_cleaning_code || $[52] !== selectedFabric.group_material || $[53] !== selectedFabric.option_value_tier || $[54] !== selectedFabric.pantone_flag || $[55] !== selectedFabric.pet_friendly || $[56] !== selectedFabric.sustainable_fabric || $[57] !== showAttr) {
    t27 = showAttr && <FabricAdditionalAttributes selectedItemGroupMaterial={selectedFabric.group_material} selectedItemGroupCleaningCode={selectedFabric.group_cleaning_code} isPetAndKidFriendly={!!selectedFabric.pet_friendly} isSustainable={!!selectedFabric.sustainable_fabric} isGreenguardGold={!!selectedFabric.greenguard_fabric} selectedItemTier={selectedFabric.option_value_tier} isPantoneFabric={selectedFabric.pantone_flag} />;
    $[50] = selectedFabric.greenguard_fabric;
    $[51] = selectedFabric.group_cleaning_code;
    $[52] = selectedFabric.group_material;
    $[53] = selectedFabric.option_value_tier;
    $[54] = selectedFabric.pantone_flag;
    $[55] = selectedFabric.pet_friendly;
    $[56] = selectedFabric.sustainable_fabric;
    $[57] = showAttr;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== selectedFabric.option_description) {
    t28 = <SanitizedHtml className="mx-0 my-6 text-sm" html={selectedFabric.option_description} />;
    $[59] = selectedFabric.option_description;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== mode || $[62] !== onClose) {
    t29 = mode !== "quickview" && <div className="mb-12"><PDPFreeSwatchKitButton onClick={() => {
        setIsOrderSwatchesSidebarOpen(true);
        onClose();
      }} /></div>;
    $[61] = mode;
    $[62] = onClose;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== reviews) {
    t30 = <PDPFabricReviews reviews={reviews} />;
    $[64] = reviews;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== t25 || $[67] !== t26 || $[68] !== t27 || $[69] !== t28 || $[70] !== t29 || $[71] !== t30) {
    t31 = <div className="px-8 py-10 max-[767px]:p-4">{t25}{t26}{t27}{t28}{t29}{t30}</div>;
    $[66] = t25;
    $[67] = t26;
    $[68] = t27;
    $[69] = t28;
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t21 || $[74] !== t22 || $[75] !== t23 || $[76] !== t31) {
    t32 = <div className={t21}>{t22}{t23}{t31}</div>;
    $[73] = t21;
    $[74] = t22;
    $[75] = t23;
    $[76] = t31;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== isOpen || $[79] !== mobileHideHeader || $[80] !== onClose || $[81] !== t32) {
    t33 = <SidebarModal isOpen={isOpen} onClose={onClose} mobileNoPadding={true} desktopNoPadding={true} desktopNoCloseIcon={true} desktopWidthSize="lg" mobileHideHeader={mobileHideHeader} mobileIsFullHeight={true}>{t32}</SidebarModal>;
    $[78] = isOpen;
    $[79] = mobileHideHeader;
    $[80] = onClose;
    $[81] = t32;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  let t35;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    t35 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    $[83] = t34;
    $[84] = t35;
  } else {
    t34 = $[83];
    t35 = $[84];
  }
  let t36;
  if ($[85] !== isOrderSwatchesSidebarOpen) {
    t36 = <PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={t34} closeSlidePanel={t35} />;
    $[85] = isOrderSwatchesSidebarOpen;
    $[86] = t36;
  } else {
    t36 = $[86];
  }
  let t37;
  if ($[87] !== t33 || $[88] !== t36) {
    t37 = <>{t33}{t36}</>;
    $[87] = t33;
    $[88] = t36;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  return t37;
};
PDPFabricDetailSidebarUI.propTypes = {
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onClose: PropTypes.func,
  rating: PropTypes.number,
  reviews: PropTypes.array,
  galleryType: PropTypes.string,
  selectedFabric: PropTypes.shape({
    option_value: PropTypes.string,
    option_description: PropTypes.string,
    group_material: PropTypes.string,
    group_cleaning_code: PropTypes.string,
    pet_friendly: PropTypes.number,
    exclude_from_sale: PropTypes.bool,
    sustainable_fabric: PropTypes.number,
    option_value_tier: PropTypes.number,
    fabricURL: PropTypes.string,
    fabricFallbackURL: PropTypes.string,
    sliderImages: PropTypes.array,
    option_value_id: PropTypes.number,
    option_color: PropTypes.string,
    location: PropTypes.string,
    greenguard_fabric: PropTypes.bool
  }),
  mobileHideHeader: PropTypes.bool
};
export default withBrowserOnly(PDPFabricDetailSidebarUI);